export default [
  {
    header: 'Игры',
  },
  {
    title: 'Список игр',
    route: 'games',
    icon: 'CastIcon',
    tagVariant: 'light-warning',
  },
  {
    title: 'Создать игру',
    route: 'random-game-create',
    icon: 'CastIcon',
    tagVariant: 'light-warning',
  },
  {
    title: 'Импорт расписания',
    route: 'schedule-import',
    icon: 'CalendarIcon',
    tagVariant: 'light-warning',
  },
  {
    title: 'Игровые недели',
    route: 'game-weeks',
    icon: 'CalendarIcon',
    tagVariant: 'light-warning',
  },
  {
    title: 'Построитель игр',
    route: 'game-builder-list',
    icon: 'ToolIcon',
    tagVariant: 'light-warning',
  },
]
